import { useCallback, useRef } from 'react';

type UseSyncHorizontalScrollParams = {
    syncedScrollRefs: React.RefObject<HTMLElement>[];
};

export const useSyncHorizontalScroll = ({ syncedScrollRefs }: UseSyncHorizontalScrollParams) => {
    const isScrollingSyncRef = useRef(false);
    const syncedScrollRefsRef = useRef(syncedScrollRefs);

    syncedScrollRefsRef.current = syncedScrollRefs;

    const handleSyncHorizontalScroll = useCallback((ev: React.UIEvent<HTMLElement>) => {
        if (isScrollingSyncRef.current) {
            return;
        }

        isScrollingSyncRef.current = true;
        const scrollLeft = ev.currentTarget.scrollLeft;

        syncedScrollRefsRef.current.forEach((syncedScrollRef) => {
            if (syncedScrollRef.current && syncedScrollRef.current !== ev.currentTarget) {
                syncedScrollRef.current.scrollLeft = scrollLeft;
            }
        });

        requestAnimationFrame(() => {
            isScrollingSyncRef.current = false;
        });
    }, []);

    return { handleSyncHorizontalScroll };
};
